export class CancellationReason {
    code: string;
    description: string;
    constructor() {
        this.code = "";
        this.description = "";
    }
}